import { css } from 'lit';
import { get } from 'lodash';
import { DotNotationPath } from '@typings/shared-types';
import { DraftEvent, LocationTypes, RoadEventDto } from '../../typings/api';
import { APIErrorJSON } from '../../typings/shared-types';
import { isLaneImpacted, isValidNumber, isValidString } from './utils';

export const isLatLngLiteral = (target: unknown): target is L.LatLngLiteral => {
	const { lat, lng } = target as L.LatLngLiteral;
	if (lat && lng) {
		return true;
	}
	return false;
};

export const isLatLngBoundsLiteral = (target: unknown): target is L.LatLngBoundsLiteral => {
	const latLngBoundsLiteral = target as L.LatLngBoundsLiteral;
	if (
		latLngBoundsLiteral?.length === 2 &&
		isLatLngLiteral(latLngBoundsLiteral[0]) &&
		isLatLngLiteral(latLngBoundsLiteral[1])
	) {
		return true;
	}
	return false;
};

export const isREMEvent = (target: unknown): target is RoadEventDto => {
	const remEvent = target as RoadEventDto;
	if (
		!!remEvent?.id &&
		!!remEvent?.eventType &&
		!!remEvent?.priorityLevel &&
		!!remEvent?.dateStart
	) {
		return true;
	}
	return false;
};

export const isREMDraftEvent = (
	target: unknown,
	requiredFields: Array<DotNotationPath<RoadEventDto>>,
): target is DraftEvent => {
	if (target == null) {
		return false;
	}

	const remEvent = target as DraftEvent;

	// special checks for lane impacts on major roads, field must not be null AND have at least one impacted lane/shoulder
	if (
		(requiredFields.includes('positiveLaneBlockage') ||
			requiredFields.includes('negativeLaneBlockage')) &&
		remEvent.eventLocation === LocationTypes.MAJOR_ROAD &&
		!isLaneImpacted(remEvent.positiveLaneBlockage) &&
		!isLaneImpacted(remEvent.negativeLaneBlockage)
	) {
		return false;
	}

	// check configured required fields are present
	if (!requiredFields.every((field) => get(remEvent, field) != null)) {
		return false;
	}

	if (
		remEvent.eventLocation === LocationTypes.LOCAL_ROAD &&
		remEvent.locationDetails?.crossStreetStart === undefined
	) {
		return false;
	}

	if ((remEvent?.respondingUnits ?? []).every((unit) => isValidString(unit.unitType))) {
		return true;
	}

	return false;
};

export const isAPIErrorJSON = (target: unknown): target is APIErrorJSON => {
	const apiErrorJson = target as APIErrorJSON;
	if (
		isValidString(apiErrorJson.error) &&
		isValidString(apiErrorJson.message) &&
		isValidString(apiErrorJson.path) &&
		isValidString(apiErrorJson.timestamp) &&
		isValidNumber(apiErrorJson.status)
	) {
		return true;
	}
	return false;
};
